export const SOCIAL_LOGIN_PLATFORMS = {
  GOOGLE: 'GOOGLE',
};
export const ERROR_STATUS_CODE = {
  EMAIL_VERIFIED_ERROR: 'alg_wc_ev_email_verified_error',
  INCORRECT_PASSWORD: 'incorrect_password',
  INVALID_EMAIL: 'invalid_email',
};

export const SELECTION_COLUMN = 'selection_column';

export const QUERY_MOBILE = '62em';

export const TODAY_DEEPLINK =
  'https://easeapp.page.link/?link=https://easeapp.page.link/today&ibi=org.ease.EaseApp&apn=com.easeapp';
